import { useMemo } from 'react'
import { Trash2 } from 'lucide-react'

export default function TabProductos({ details, isExenta, onChange }) {
  const MAX_PRODUCTOS = 10

  const setRow = (i, k, v) => {
    let value = v

    // Solo aplicar lógica de Number a los campos que realmente son numéricos
    const numericFields = ['quantity', 'unit_price', 'discount_percent']
    if (numericFields.includes(k)) {
      value = v === '' ? '' : Number(v)
    }

    const next = details.map((d, idx) => (idx === i ? { ...d, [k]: value } : d))
    onChange(next.map((d, idx) => ({ ...d, line_number: idx + 1 })))
  }

  const addRow = () => {
    if ((details?.length || 0) >= MAX_PRODUCTOS) return
    onChange([
      ...(details || []),
      {
        item_name: '',
        quantity: 1,
        unit_price: 0,
        discount_percent: '',
        line_number: (details?.length || 0) + 1
      }
    ])
  }

  const removeRow = i =>
    onChange(
      details.filter((_, idx) => idx !== i).map((d, idx) => ({ ...d, line_number: idx + 1 }))
    )

  const resumen = useMemo(() => {
    let neto = 0
      ; (details || []).forEach(d => {
        const q = Number(d.quantity || 0)
        const p = Number(d.unit_price || 0)
        const disc = Number(d.discount_percent || 0)
        const bruto = q * p
        const net = bruto * (1 - disc / 100)
        neto += net
      })
    const ivaRate = isExenta ? 0 : 0.19
    const netoRedondeado = Math.round(neto)
    const ivaRedondeado = Math.round(netoRedondeado * ivaRate)
    const totalRedondeado = netoRedondeado + ivaRedondeado
    return {
      neto: netoRedondeado,
      iva: ivaRedondeado,
      total: totalRedondeado,
      ivaRate: ivaRate * 100
    }
  }, [details, isExenta])

  return (
    <div className='p-1 mt-1'>
      {/* 🧾 Encabezado */}
      <div className='flex justify-between items-center mb-2'>
        <div>
          <h2 className='text-lg font-bold text-slate-800'>Detalle de Productos</h2>
          <p className='text-[0.75rem] text-slate-400 mt-0.5 tracking-wide'>
            Máximo {MAX_PRODUCTOS} productos ({details.length}/{MAX_PRODUCTOS})
          </p>
        </div>
        <button
          className={`flex text-m items-center gap-1.5 px-4 py-1 rounded-full text-white tracking-wide transition-all shadow-md ${details.length >= MAX_PRODUCTOS
            ? 'bg-slate-300 shadow-none cursor-not-allowed text-slate-100'
            : 'bg-accent2 text-white rounded-full'
            }`}
          onClick={addRow}
          disabled={details.length >= MAX_PRODUCTOS}
        >
          <span className='text-[10px]'>+</span> Agregar Detalle
        </button>
      </div>

      {/* 📋 Tabla de productos */}
      <div className='max-h-[200px] overflow-y-auto overflow-x-auto rounded-xl border border-slate-100 shadow-sm'>
        <table className='w-full text-sm font-sans whitespace-nowrap min-w-[700px]'>
          <thead className='bg-slate-50/90 border-b border-slate-100 sticky top-0 z-10 backdrop-blur-md'>
            <tr>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-left w-3/12'>
                Nombre
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-left'>
                Descripción
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-right w-24'>
                Cant.
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-right w-32'>
                Precio Univ.
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-right w-20'>
                % Desc
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-center w-14'></th>
            </tr>
          </thead>
          <tbody className='divide-y divide-slate-100'>
            {(details || []).map((d, i) => (
              <tr key={i} className='bg-white hover:bg-slate-50/50 transition-colors group'>
                <td className='p-2'>
                  <input
                    className='custom-input text-slate-700'
                    placeholder='Nombre...'
                    value={d.item_name || ''}
                    onChange={e => setRow(i, 'item_name', e.target.value)}
                  />
                </td>
                <td className='p-2'>
                  <input
                    className='custom-input text-slate-500 bg-transparent shadow-none border-transparent hover:bg-slate-50 focus:bg-white focus:border-blue-500/30'
                    placeholder='Descripción...'
                    value={d.item_description || ''}
                    onChange={e => setRow(i, 'item_description', e.target.value)}
                  />
                </td>
                <td className='p-2'>
                  <input
                    type='number'
                    className='custom-input text-right text-slate-700 font-medium'
                    value={d.quantity ?? ''}
                    onFocus={e => e.target.select()}
                    onChange={e => setRow(i, 'quantity', e.target.value)}
                  />
                </td>
                <td className='p-2'>
                  <div className='relative'>
                    <span className='absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs'>
                      $
                    </span>
                    <input
                      type='number'
                      className='custom-input text-right pl-6 text-slate-700 font-medium'
                      value={d.unit_price ?? ''}
                      onFocus={e => e.target.select()}
                      onChange={e => setRow(i, 'unit_price', e.target.value)}
                    />
                  </div>
                </td>
                <td className='p-2'>
                  <div className='relative'>
                    <input
                      type='number'
                      className='custom-input text-right pr-6 font-medium'
                      value={d.discount_percent ?? ''}
                      onFocus={e => e.target.select()}
                      onChange={e => setRow(i, 'discount_percent', e.target.value)}
                    />
                  </div>
                </td>
                <td className='p-2 text-center align-middle'>
                  <button
                    className='px-2 py-1 rounded-md text-red-700 flex items-center'
                    onClick={() => removeRow(i)}
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 💰 Resumen de totales interactivo */}
      <div className='mt-4 flex flex-col md:flex-row justify-end'>
        <div className='w-full md:w-80 bg-slate-50/50 border border-slate-200/50 rounded-2xl py-1 px-2 flex flex-col gap-2 shadow-sm'>
          <div className='flex justify-between items-center text-sm'>
            <span className='text-slate-500 font-medium'>Subtotal neto</span>
            <span className='text-slate-700 font-semibold'>
              ${resumen.neto.toLocaleString('es-CL')}
            </span>
          </div>
          <div className='flex justify-between items-center text-sm border-b border-slate-200/60 pb-1'>
            <span className='text-slate-500 font-medium'>IVA ({resumen.ivaRate}%)</span>
            <span className='text-slate-700 font-semibold'>
              ${resumen.iva.toLocaleString('es-CL')}
            </span>
          </div>
          <div className='flex justify-between items-center'>
            <span className='text-slate-800 font-semibold tracking-tight'>Monto Total</span>
            <span className='text-lg font-semibold text-slate-900 tracking-tight'>
              ${resumen.total.toLocaleString('es-CL')}
            </span>
          </div>
        </div>
      </div>

      <style>{`
        .custom-input {
          width: 100%;
          min-height: 38px;
          padding: 0px 10px;
          background-color: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 0.75rem;
          outline: none;
          font-size: 0.75rem;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        }
        .custom-input:focus {
          background-color: #ffffff;
          border-color: rgba(37, 99, 235, 0.5); /* blue-600 */
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
        }
        /* Ocultar flechas de inputs numéricos */
        input[type=number]::-webkit-inner-spin-button, 
        input[type=number]::-webkit-outer-spin-button { 
          -webkit-appearance: none; 
          margin: 0; 
        }
        input[type=number] {
          -moz-appearance: textfield;
        }
        /* Custom scrollbar for premium feel */
        .overflow-y-auto::-webkit-scrollbar {
          width: 5px;
        }
        .overflow-y-auto::-webkit-scrollbar-track {
          background: transparent;
        }
        .overflow-y-auto::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 10px;
        }
        .overflow-y-auto::-webkit-scrollbar-thumb:hover {
          background: #cbd5e1;
        }
      `}</style>
    </div>
  )
}
